import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApi } from '@core/base/base-api';
import { FieldAffiliate } from '@shared/organisation/field-affiliate/field-affiliate';
import { Organisation } from '@shared/organisation/organisation';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FieldAffiliateApiService extends BaseApi<FieldAffiliate> {
  constructor(httpClient: HttpClient) {
    super(httpClient, 'fieldaffiliates');
  }

  linkOrganisation(fieldAffiliate: FieldAffiliate, organisation: Organisation): Observable<void> {
    return this.httpClient.post<void>(
      `${this.endpoint}/${fieldAffiliate.uuid}/link/organisation/${organisation.uuid}`,
      {},
    );
  }

  unlinkOrganisation(fieldAffiliate: FieldAffiliate, organisation: Organisation): Observable<void> {
    return this.httpClient.post<void>(
      `${this.endpoint}/${fieldAffiliate.uuid}/unlink/organisation/${organisation.uuid}`,
      {},
    );
  }

  create(): FieldAffiliate {
    return new FieldAffiliate();
  }
}
